import localStorageManager from '@/utils/localStorageManager'

const approvalDeadlinesStore = new localStorageManager('approvalDeadlines', 1) // 1 minute TTL

export default approvalDeadlinesStore
